import Codon from './Codon'

const protein = (codon) => {
  const codonObj = Codon.find(codonObj => codonObj.codon === codon)
  return codonObj?.protein
}

export default protein